import React from "react";
import { Group, Text, Button, Paper } from "@mantine/core";
import { Display } from "@/utils/api/DisplayService";

export interface DisplayLinkItemProps {
  /** Display to show */
  display: Display;

  /** Function called when user clicks link button */
  onLink: (display: Display) => void;

  /** Whether linking is in progress */
  isLinking: boolean;

  /** Whether this display is currently being linked */
  isCurrentlyLinking: boolean;
}

export const DisplayLinkItem: React.FC<DisplayLinkItemProps> = ({
  display,
  onLink,
  isLinking,
  isCurrentlyLinking,
}) => {
  const handleLink = () => {
    onLink(display);
  };

  return (
    <Paper
      p="md"
      withBorder
      style={(theme) => ({
        backgroundColor: theme.colors.white,
        cursor: isLinking ? "not-allowed" : "default",
        opacity: isLinking && !isCurrentlyLinking ? 0.6 : 1,
      })}
    >
      <Group justify="space-between" align="center">
        <div style={{ flex: 1 }}>
          <Text size="md" fw={500} c="gray.8">
            {display.name || "Unnamed Display"}
          </Text>
          {display.description && (
            <Text size="sm" c="dimmed" mt="xs">
              {display.description}
            </Text>
          )}
        </div>

        <Button
          onClick={handleLink}
          loading={isCurrentlyLinking}
          disabled={isLinking}
          size="sm"
          variant="filled"
          color="blue"
        >
          {isCurrentlyLinking ? "Linking..." : "Link Display"}
        </Button>
      </Group>
    </Paper>
  );
};
